module.exports = __webpack_public_path__ + "img/intro-trial-stay.f93549c1.svg";